// extracted by mini-css-extract-plugin
export default {"page":"TnC_page__h5xvc","container":"TnC_container__qIjLr","intro":"TnC_intro__mCgro","section":"TnC_section__kDhrY"};